import { Component, Input, OnInit, TemplateRef } from '@angular/core';
import { Constant } from '../../infrastructure/constant';
import { StorageType, PersistenceService } from 'angular-persistence';
import { MessageService } from 'primeng/components/common/messageservice';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService, UserService } from '../../services';
import { BaseComponent } from '../../shared/components/baseComponent';
import { PermissionService } from '../../services/permission.service';
import { CoreSignalRService } from '../../services/core-signal-r.service';

@Component({
  selector: 'app-verify-login',
  templateUrl: './verify-login.component.html',
  styles: []
})
export class VerifyLoginComponent implements OnInit {

  @Input() userName:string
  @Input() publicKey:string
  constructor(
    private persistenceService: PersistenceService,
    protected messageService: MessageService,
    protected router: Router,
    private routeActive: ActivatedRoute,
    private modalService: BsModalService,
    private userService: UserService,
    public permissionService: PermissionService,
    private authService: AuthService,
    private signalRService : CoreSignalRService
  ) {
    this.signalRService.checkSendQrCode.subscribe(x => {
      this.completedAccess(x);
    })
  }

  modalTitle: any;
  bsModalRef: BsModalRef
  user: any;
  hide: boolean;

  currentPassWord: string;
  newPassWord: string;
  reNewPassWord: string;

  public hourLogin: number;
  public minuteLogin: number;
  async ngOnInit() {
    this.routeActive.queryParams.subscribe(params => {
      this.userName = params['userName'];
      this.publicKey = params['publicKey'];
    });
    await this.signalRService.Connect();
    await this.signalRService.registerUserToHub(this.publicKey);
    await this.signalRService.sendAccessKey();
  }
  completedAccess(data) {
    this.user = data;
  }

  ngOnDestroy() {
    this.signalRService.Disconnect();
  }

  verified(template: TemplateRef<any>) {
    if (this.user["token"] != "" && this.user["accessKey"] != "") {
      this.persistenceService.set(Constant.auths.userId, this.user["userId"], { type: StorageType.LOCAL });
      this.persistenceService.set(Constant.auths.userName, this.user["userName"], { type: StorageType.LOCAL });
      this.persistenceService.set(Constant.auths.fullName, this.user["userFullName"], { type: StorageType.LOCAL });
      this.persistenceService.set(Constant.auths.datetimeLogin, new Date(), { type: StorageType.LOCAL });
      // this.persistenceService.set(this.userName, this.user["accessKey"], { type: StorageType.LOCAL });

      if (this.user.isPassWordBasic) {
        this.openModelResetPassWord(template);
      } else {
        this.messageService.add({ severity: 'success', detail: 'Đã xác minh đăng nhập thành công.' });
        this.persistenceService.set(Constant.auths.isLoginIn, 'true', { type: StorageType.LOCAL });
        this.persistenceService.set(Constant.auths.token, this.user["token"], { type: StorageType.LOCAL });

        const routing = "";
        this.router.navigate([routing]);
      }
    }
  }

  openModelResetPassWord(template: TemplateRef<any>) {
    this.modalTitle = "Đây là lần đăng nhập đầu tiên, vui lòng đổi mật khẩu mới";
    this.bsModalRef = this.modalService.show(template, {
      class: "inmodal bounceInRight modal-s"
    });
  }

  showPassword() {
    this.hide = !this.hide;
  }

  async firstResetPassWord() {
    this.messageService.clear();
    if (!this.isValid()) return;
    const res = await this.changePassWord().toPromise();
    if (res) {
      this.bsModalRef.hide();
      const routing = "";
      this.router.navigate([routing]);
    }
  }

  changePassWord(): any {
    if (!this.isValid()) return;
    return this.userService.changePassWord(this.currentPassWord, this.newPassWord).map(
      x => {
        if (!x.isSuccess){
          this.messageService.add({ severity: Constant.messageStatus.success, detail: x.message });
          return;
        } 
        var today = new Date();
        this.hourLogin = Number(today.getHours());
        this.minuteLogin = Number(today.getMinutes());
        this.authService.login(this.authService.getUserName(), this.newPassWord, this.hourLogin, this.minuteLogin);
        this.messageService.add({ severity: Constant.messageStatus.success, detail: "Thay đổi mật khẩu thành công" });
        return true;
      }
    );
  }

  isValid(): boolean {
    if (!this.currentPassWord) {
      this.messageService.add({ severity: Constant.messageStatus.warn, detail: "Chưa nhập mật khẩu hiện tại" });
      return false;
    } else if (!this.newPassWord) {
      this.messageService.add({ severity: Constant.messageStatus.warn, detail: "Chưa nhập mật khẩu mới" });
      return false;
    } else if (!this.reNewPassWord) {
      this.messageService.add({ severity: Constant.messageStatus.warn, detail: "Chưa xác thực lại mật khẩu mới" });
      return false;
    } else if (this.newPassWord !== this.reNewPassWord) {
      this.messageService.add({ severity: Constant.messageStatus.warn, detail: "Mật khẩu xác thực không khớp" });
      return false;
    }
    return true;
  }

}
